export default __webpack_public_path__ + "static/media/img08.c3470f52.jpg";